const GetTotalPage = (total, perPage) => {
    return Math.ceil(total/perPage);
}

export {
    GetTotalPage
}